import { isAxiosError } from 'axios';

type ApiErrorMessagesOptions = {
  fallback?: string;
  parseMessage?: (message: string) => string[] | null;
};

function flattenValidationErrors (errors: unknown): string[] {
  if (!errors || typeof errors !== 'object') {
    return [];
  }

  return Object.values(errors as Record<string, unknown>)
    .flat()
    .filter((message): message is string => typeof message === 'string' && message.trim() !== '');
}

export function apiErrorMessagesFromData (
  data: unknown,
  options: Pick<ApiErrorMessagesOptions, 'parseMessage'> = {},
): string[] | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const payload = data as { errors?: unknown; message?: unknown };

  const fromValidation = flattenValidationErrors(payload.errors);
  if (fromValidation.length > 0) {
    return fromValidation;
  }

  if (typeof payload.message === 'string' && payload.message.trim() !== '') {
    const fromParser = options.parseMessage?.(payload.message);
    if (fromParser !== undefined && fromParser !== null && fromParser.length > 0) {
      return fromParser;
    }

    return [payload.message];
  }

  return null;
}

export function apiErrorMessages (
  err: unknown,
  options: ApiErrorMessagesOptions = {},
): string[] {
  const fallback = options.fallback ?? 'Something went wrong.';

  if (!isAxiosError(err)) {
    return [fallback];
  }

  const messages = apiErrorMessagesFromData(err.response?.data, options);
  return messages ?? [fallback];
}
